import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_26c5057c from 'nuxt_plugin_plugin_26c5057c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_3d240187 from 'nuxt_plugin_bootstrapvue_3d240187' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_workbox_4c220b18 from 'nuxt_plugin_workbox_4c220b18' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_5e9ee4f2 from 'nuxt_plugin_metaplugin_5e9ee4f2' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_554f9a0a from 'nuxt_plugin_iconplugin_554f9a0a' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_b7a00950 from 'nuxt_plugin_axios_b7a00950' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_lodash_5d4c7b8c from 'nuxt_plugin_lodash_5d4c7b8c' // Source: ../plugins/lodash.js (mode: 'client')
import nuxt_plugin_sentry_e47869fc from 'nuxt_plugin_sentry_e47869fc' // Source: ../plugins/sentry.js (mode: 'all')
import nuxt_plugin_pwa_4462a11a from 'nuxt_plugin_pwa_4462a11a' // Source: ../plugins/pwa.js (mode: 'client')
import nuxt_plugin_globalmethods_b266668e from 'nuxt_plugin_globalmethods_b266668e' // Source: ../plugins/global-methods.js (mode: 'client')
import nuxt_plugin_scrollPicker_e78ccfb4 from 'nuxt_plugin_scrollPicker_e78ccfb4' // Source: ../plugins/scrollPicker.js (mode: 'client')
import nuxt_plugin_veevalidate_1a0c1998 from 'nuxt_plugin_veevalidate_1a0c1998' // Source: ../plugins/vee-validate.js (mode: 'client')
import nuxt_plugin_toasted_70bd5f27 from 'nuxt_plugin_toasted_70bd5f27' // Source: ../plugins/toasted.js (mode: 'client')
import nuxt_plugin_vertepicker_478c698c from 'nuxt_plugin_vertepicker_478c698c' // Source: ../plugins/verte-picker.js (mode: 'all')
import nuxt_plugin_vuesimplesuggest_3bbbc0b1 from 'nuxt_plugin_vuesimplesuggest_3bbbc0b1' // Source: ../plugins/vue-simple-suggest.js (mode: 'all')
import nuxt_plugin_ripple_08c101de from 'nuxt_plugin_ripple_08c101de' // Source: ../plugins/ripple.js (mode: 'client')
import nuxt_plugin_dateFormat_86e75a48 from 'nuxt_plugin_dateFormat_86e75a48' // Source: ../plugins/dateFormat.js (mode: 'all')
import nuxt_plugin_globalFormat_72a4f807 from 'nuxt_plugin_globalFormat_72a4f807' // Source: ../plugins/globalFormat.js (mode: 'all')
import nuxt_plugin_vuefloatactionbutton_c6e063c8 from 'nuxt_plugin_vuefloatactionbutton_c6e063c8' // Source: ../plugins/vue-float-action-button.js (mode: 'client')
import nuxt_plugin_signalPlugin_137c91e6 from 'nuxt_plugin_signalPlugin_137c91e6' // Source: ../plugins/signalPlugin.js (mode: 'client')
import nuxt_plugin_eventBus_aaeb250a from 'nuxt_plugin_eventBus_aaeb250a' // Source: ../plugins/eventBus.js (mode: 'client')
import nuxt_plugin_auth_5b9ae2d8 from 'nuxt_plugin_auth_5b9ae2d8' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"","titleTemplate":"%s - Suivi temps | Easytpe","bodyAttrs":{},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"description","name":"description","content":"Simplifier la saisie, validation et gestion des temps de travail grâce à suivitemps de Easy Tpe."},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Ffont-awesome\u002F5.15.3\u002Fcss\u002Fall.min.css"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Round"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:wght@400;500;600;700;800&display=swap"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap "}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_26c5057c === 'function') {
    await nuxt_plugin_plugin_26c5057c(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_3d240187 === 'function') {
    await nuxt_plugin_bootstrapvue_3d240187(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_4c220b18 === 'function') {
    await nuxt_plugin_workbox_4c220b18(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_5e9ee4f2 === 'function') {
    await nuxt_plugin_metaplugin_5e9ee4f2(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_554f9a0a === 'function') {
    await nuxt_plugin_iconplugin_554f9a0a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_b7a00950 === 'function') {
    await nuxt_plugin_axios_b7a00950(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lodash_5d4c7b8c === 'function') {
    await nuxt_plugin_lodash_5d4c7b8c(app.context, inject)
  }

  if (typeof nuxt_plugin_sentry_e47869fc === 'function') {
    await nuxt_plugin_sentry_e47869fc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pwa_4462a11a === 'function') {
    await nuxt_plugin_pwa_4462a11a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globalmethods_b266668e === 'function') {
    await nuxt_plugin_globalmethods_b266668e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrollPicker_e78ccfb4 === 'function') {
    await nuxt_plugin_scrollPicker_e78ccfb4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_1a0c1998 === 'function') {
    await nuxt_plugin_veevalidate_1a0c1998(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toasted_70bd5f27 === 'function') {
    await nuxt_plugin_toasted_70bd5f27(app.context, inject)
  }

  if (typeof nuxt_plugin_vertepicker_478c698c === 'function') {
    await nuxt_plugin_vertepicker_478c698c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesimplesuggest_3bbbc0b1 === 'function') {
    await nuxt_plugin_vuesimplesuggest_3bbbc0b1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ripple_08c101de === 'function') {
    await nuxt_plugin_ripple_08c101de(app.context, inject)
  }

  if (typeof nuxt_plugin_dateFormat_86e75a48 === 'function') {
    await nuxt_plugin_dateFormat_86e75a48(app.context, inject)
  }

  if (typeof nuxt_plugin_globalFormat_72a4f807 === 'function') {
    await nuxt_plugin_globalFormat_72a4f807(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuefloatactionbutton_c6e063c8 === 'function') {
    await nuxt_plugin_vuefloatactionbutton_c6e063c8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_signalPlugin_137c91e6 === 'function') {
    await nuxt_plugin_signalPlugin_137c91e6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_eventBus_aaeb250a === 'function') {
    await nuxt_plugin_eventBus_aaeb250a(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_5b9ae2d8 === 'function') {
    await nuxt_plugin_auth_5b9ae2d8(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    const { route } = router.resolve(app.context.route.fullPath)
    // Ignore 404s rather than blindly replacing URL
    if (!route.matched.length && process.client) {
      return resolve()
    }
    router.replace(route, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
